import { createSlice } from '@reduxjs/toolkit';

const AUCTION_INITIAL_STATE = {
  auctionDialog: {
    AuctionId: null,
    DateFrom: null,
    DateTo: null,
  },
  auctionVehicleDialog: {},
};

const auctionSlice = createSlice({
  name: 'auction',
  initialState: AUCTION_INITIAL_STATE,
  reducers: {
    setAuctionDialog(state, action) {
      state.auctionDialog = action.payload;
    },
    setAuctionVehicleDialog(state, action) {
      state.auctionVehicleDialog = action.payload;
    },
  },
});

export const {
  setAuctionDialog,
  setAuctionVehicleDialog,
} = auctionSlice.actions;

export default auctionSlice.reducer;
